import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
  USER_FORGET,
  USER_FORGET_SUCCESS
} from "constants/ActionTypes";
import { ACTIVE_USER, ACTIVE_USER_SUCCESS, CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_USER_PASSWORD, CLEAR_TOKEN, SET_TOKEN, SIGNIN_EXTERNAL_USER, SIGNIN_EXTERNAL_USER_CALLBACK, SIGNIN_EXTERNAL_USER_CALLBACK_SUCCESS, SIGNIN_EXTERNAL_USER_SUCCESS } from "../../constants/ActionTypes";

export const activeUser = (token) => {
  return {
    type: ACTIVE_USER,
    payload: token
  };
};

export const activeUserSuccess = (activeUser) => {
  return {
    type: ACTIVE_USER_SUCCESS,
    payload: activeUser
  };
};

export const userSignUp = (user) => {
  return {
    type: SIGNUP_USER,
    payload: user
  };
};

export const userSignIn = (user) => {
  return {
    type: SIGNIN_USER,
    payload: user
  };
};
export const setToken = (token) => {
  return {
    type: SET_TOKEN,
    payload: token
  };
};

export const userExternalSignIn = (user) => {
  return {
    type: SIGNIN_EXTERNAL_USER,
    payload: user
  };
};
export const userExternalSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_EXTERNAL_USER_SUCCESS,
    payload: authUser
  }
};
export const userExternalSignInCallBack = (token) => {
  return {
    type: SIGNIN_EXTERNAL_USER_CALLBACK,
    payload: token
  };
};
export const userExternalSignInCallBackSuccess = (authUser) => {
  return {
    type: SIGNIN_EXTERNAL_USER_CALLBACK_SUCCESS,
    payload: authUser
  }
};
export const changePassword = (data) => {
  return {
    type: CHANGE_PASSWORD,
    payload: data
  };
};
export const changeUserPassword = (data) => {
  return {
    type: CHANGE_USER_PASSWORD,
    payload: data
  };
};

export const changePasswordSuccess = (result) => {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    payload: result
  };
};

export const userForget = (user) => {
  return {
    type: USER_FORGET,
    payload: user
  };
};

export const userForgetSuccess = (authUser) => {
  return {
    type: USER_FORGET_SUCCESS,
    payload: authUser
  };
};
export const userSignOut = () => {
  return {
    type: SIGNOUT_USER
  };
};

export const userSignUpSuccess = (authUser) => {
  return {
    type: SIGNUP_USER_SUCCESS,
    payload: authUser
  };
};

export const userSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: authUser
  }
};
export const userSignOutSuccess = () => {
  return {
    type: SIGNOUT_USER_SUCCESS,
  }
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};
export const clearToken = () => {
  return {
    type: CLEAR_TOKEN
  };
};

export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};
export const hideAuthLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};
